import React, { useEffect, useMemo, useState } from "react";
import { ChildrenRequirementLayout, DeliverableSwitch, DeliverablesTabLayout } from "..";
import { DeliverablesService } from "../../../../../../../../../api";
import styles from "./DeliverablesTabContent.module.css";
import { useApi } from "../../../../../../../../../common/hooks";
import { translate } from "../../../../../../../../../common/providers";
import { ViewTabs } from "../../../../../../../../../common/components";

export default function DeliverablesTabContent({ reqId, coverageStatus, onUpdate, onSetSelectedTab, selectedTab }) {
	const { call: updateCoverageStatus } = useApi(DeliverablesService.updateCoverageStatus);
	const { call: getCoverageStatus } = useApi(DeliverablesService.getCoverageStatus);
	const [tempCoverage, setTempCoverage] = useState(coverageStatus);
	const [delivSelectedTab, setDelivSelectedTab] = useState("deliverables");
	const tabHeaders = useMemo(
		() => [
			{
				id: "deliverables",
				label: translate("smart-review.cmp-details.option-panel.deliverables"),
			},
			{
				id: "childrenReq",
				label: translate("smart-review.cmp-details.option-panel.children-requirements"),
			},
		],
		[]
	);

	useEffect(() => {
		getCoverageStatus({ reqId })
			.then((data) => setTempCoverage(data))
			.catch(console.error);
	}, [reqId, getCoverageStatus]);
	const updateCoverageStatusService = (status) => {
		updateCoverageStatus({ reqId }, status)
			.then(() => {
				onUpdate(status);
			})
			.catch((err) => {
				console.error(err);
			});
	};
	const handleChangeTab = (_, tab) => {
		setDelivSelectedTab(tab);
	};
	const handleCoverageStatusChange = (event) => {
		const { checked } = event.target;
		const newCoverageStatus = checked ? "TO_BE_COVERED" : "EXCLUDED";
		setTempCoverage(newCoverageStatus);
		updateCoverageStatusService(newCoverageStatus);
	};

	return (
		<div className={styles.main}>
			<div className={styles.header}>
				<div>
					<ViewTabs
						className={styles.tabs}
						selectedTab={delivSelectedTab}
						tabIdentifier="id"
						tabs={tabHeaders}
						onChange={handleChangeTab}
					/>
				</div>
				<div>
					<DeliverableSwitch
						className={styles.radios}
						coverageStatus={tempCoverage}
						onCoverageStatusChange={handleCoverageStatusChange}
					/>
				</div>
			</div>
			{(tempCoverage === "EXCLUDED" && (
				<div className={styles.emptyState}>{translate("smart-review.right-panel.deliverables.excluded")}</div>
			)) || (
				<>
					{(delivSelectedTab === "deliverables" && (
						<div className={styles.container}>
							<DeliverablesTabLayout
								reqId={reqId}
								selectedTab={selectedTab}
								onSetSelectedTab={onSetSelectedTab}
							/>
						</div>
					)) || <ChildrenRequirementLayout reqId={reqId} />}
				</>
			)}
		</div>
	);
}
